/** Naive E164 formatting to return back just digits and a + sign */
export function simpleE164Formatter(phoneNumberish: string): string {
  const justDigits = phoneNumberish.toString().replace(/\D/g, '')
  return justDigits.length === 10 && !justDigits.startsWith('1')
    ? `+1${justDigits}`
    : `+${stripLeadingZeroes(justDigits)}` // no E164 country codes start with zero
}

function stripLeadingZeroes(phoneNumber: string): string {
  return phoneNumber.replace(/^0+/, '')
}
